import { render, staticRenderFns } from "./AutoInput.vue?vue&type=template&id=2c061392&scoped=true"
import script from "./AutoInput.vue?vue&type=script&lang=js"
export * from "./AutoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c061392",
  null
  
)

export default component.exports